import { useState } from 'react';
import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { Footer, FooterButtons } from '@/design_system/Footer';
import { RequestWithRelations } from '@/models/request';
import { hasPermission } from '@/models/user';
import { useCurrentSession } from '@/services/auth';

import { ExternalPaymentOrRefundModal } from './ValidatePaymentAction/ExternalPaymentOrRefundModal/ExternalPaymentOrRefundModal';

export const ValidateRefundAction = ({
  request,
  onActionDone,
}: {
  request: RequestWithRelations;
  onActionDone: () => void;
}) => {
  const { currentSession } = useCurrentSession();

  if (
    !hasPermission(currentSession, 'validate_payment', {
      organizationId: request.organizationId,
      entityId: request.storeId,
    })
  ) {
    return null;
  }

  return <ExternalActionBar onActionDone={onActionDone} />;
};

const ExternalActionBar = ({ onActionDone }: { onActionDone: () => void }) => {
  const [isConfirmClientRefundModalOpen, setIsConfirmClientRefundModalOpen] = useState(false);

  return (
    <>
      <Footer>
        <FooterButtons>
          <Button onPress={() => setIsConfirmClientRefundModalOpen(true)}>
            <Trans id="validate-refund-action.confirm-refund.button">Confirm client refund</Trans>
          </Button>
        </FooterButtons>
      </Footer>

      {isConfirmClientRefundModalOpen && (
        <ExternalPaymentOrRefundModal
          step="refund"
          onClose={() => setIsConfirmClientRefundModalOpen(false)}
          onActionDone={onActionDone}
        />
      )}
    </>
  );
};
